import { http, httpFile } from './http_service';

// Get all
export function all(){
    return http().get('/quote');
}
//Get List for table view
export function list(){
    return http().get('/quote/list');
}
//Get List for table view - Pagination
export function listPage(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        dealerUserId:obj.dealerUserId,
        selectedStatus:obj.selectedStatus,
        fromDate:obj.fromDate,
        toDate:obj.toDate,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/quote/list-page`, {
        params:params
    });
}

//For Export Quote List
export function createQuoteListExport(obj){
  let params = {
      page:obj.page,
      recordsPerPage:obj.recordsPerPage,
      q:obj.q,
      dealerUserId:obj.dealerUserId,
      selectedStatus:obj.selectedStatus,
      fromDate:obj.fromDate,
      toDate:obj.toDate,
      sort_direction:obj.sort_direction,
      sort_field:obj.sort_field,
  }
  return http().get(`/quote/export/create-quote-list`, {
      params:params
  });
}

// Delete Export Quote List in temp folder
export function deleteTempQuoteListExport(data){
  return http().put(`/quote/export/delete-temp-quote-list`, data)
}


//Get List quote for BDM
export function listPageBDM(obj){
  let params = {
      selectedBDM: obj.selectedBDM,
      page:obj.page,
      recordsPerPage:obj.recordsPerPage,
      q:obj.q,
      selectedStatus:obj.selectedStatus,
      sort_direction:obj.sort_direction,
      sort_field:obj.sort_field
  }
  return http().get(`/quote/bdm/list-page`, {
          params:params
      }
  );
}

//Get List quote dealer for table view - Pagination 2022-04-12
export function listPageDealer(obj){
    let params = {
        dealerUserId:obj.dealerUserId,
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedStatus:obj.selectedStatus,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/quote/dealer/pagination/list`, {
            params:params
        }
    );
}

//Get List quote dealer for table view
export function quoteDealerList(dealerUserId){
    return http().get(`/quote/dealer/list/${dealerUserId}`);
}

//Get List quote dealer manager for table view
export function quoteDealerManagerList(dealerManagerId){
    return http().get(`/quote/dealer-manager/list/${dealerManagerId}`);
}

// Get all active
export function allActive(){
    return http().get('/quote/active');
}
// Get Single
export function single(id){
    return http().get(`/quote/${id}`);
}

export function updateQuoteStatus(id, data){
    return http().put(`/quote/update-quote-status/${id}`, data)
}

export function updateQuoteStatusOnly(id, data){
  return http().put(`/quote/update-quote-status-only/${id}`, data)
}

// Update privacyConsent
export function updatePrivacyConsent(id, data){
    return http().put(`/quote/update-privacy-consent/${id}`, data)
}

/**
 * Quote transfer to different user
 * @param {Integer} quoteId
 * @param {object} data
 * @returns
 */
export function transferDealer(quoteId, data){
    return http().put(`/quote/dealer/transfer/${quoteId}`, data)
}


// Delete one
export function deleteSingle(id){
    return http().delete(`/quote/${id}`);
}
// Send quote
export function sendPdfQuote(data){
    return http().post(`/send-pdf-quote`, data);
}
/**
 * Add Vehicle information
 * @param integer quoteId
 * @param object data
 * @returns
 */
export function add(data){
    return http().post('/quote/add', data)
}
/**
 * Update Vehicle information
 * @param integer quoteId
 * @param object data
 * @returns
 */
export function update(quoteId, data){
    return http().put(`/quote/update/${quoteId}`, data)
}
/**
 * Submit Vehicle information
 * @param integer quoteId
 * @param object data
 * @returns
 */
export function submit(quoteId, data){
    return http().put(`/quote/submit/${quoteId}`, data)
}



//update client details
export function updateClient(id, data){
    return http().put(`/quote/client/${id}`, data)
}

// Add or Update Employer detail
export function addOrUpdateEmploymentDetails(data){
    return http().post('/quote/client-employment-details', data)
}
// Add or Update Finance detail
export function addOrUpdateFinanceDetails(data){
    return http().post('/quote/client-finance-details', data)
}

// Create Finance doc
export function createFinanceDoc(data){
    return http().post(`/quote/create-finance-doc`, data)
}

// download Finance doc
export function deleteTempFinanceDoc(data){
    return http().put(`/quote/delete-temp-finance-doc`, data)
}

/**
 * Get Finance oll data
 */
 export function fDataAll(){
    return http().get(`/quote//f-data/all`)
}


/**
 * Download quote
 * What is going to do send to backend quote calculation data
 * create temp file in local and delete
 */
export function createQuoteDownload(data){
  return http().post(`/quote/create-quote-download`, data)
}
/**
 *
 * @returns
 */
export function deleteTempQuote(){
  return http().put(`/quote/delete-temp-quote`)
}








